import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonProjectChannelOverview } from "../../CommonComponents/CommonProjectChannelViews";
export const ProjectChannelNewRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.project().channelNew,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectChannelOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => null,
};
